import moment from 'moment-timezone';

import { urls } from './../../config';
import authFetch from './../../utils/authFetch';

import { ordersAddList } from './../orders/actions';

export const ORDERS_FIND_REQUEST = 'ORDERS_FIND_REQUEST';
export const ORDERS_FIND_RECEIVE = 'ORDERS_FIND_RECEIVE';

export const ORDERS_FIND_SET_PRICE_BOUNDS = 'ORDERS_FIND_SET_PRICE_BOUNDS';

export const ORDERS_FIND_SET_SORTING = 'ORDERS_FIND_SET_SORTING';
export const ORDERS_FIND_SET_FILTER_TIME = 'ORDERS_FIND_SET_FILTER_TIME';
export const ORDERS_FIND_SET_FILTER_PRICE = 'ORDERS_FIND_SET_FILTER_PRICE';
export const ORDERS_FIND_SET_FILTER_SEARCH = 'ORDERS_FIND_SET_FILTER_SEARCH';
export const ORDERS_FIND_SET_FILTER_SUBJECT = 'ORDERS_FIND_SET_FILTER_SUBJECT';
export const ORDERS_FIND_SET_FILTER_TYPE = 'ORDERS_FIND_SET_FILTER_TYPE';
export const ORDERS_FIND_SET_FILTER_GROUP = 'ORDERS_FIND_SET_FILTER_GROUP';

export const ORDERS_TYPE_ALL = 'all';
export const ORDERS_TYPE_FAVORITE = 'favorite';

const ordersFindSetPriceBounds = (min, max, step) => ({
    type: ORDERS_FIND_SET_PRICE_BOUNDS,
    min,
    max,
    step
});

const ordersFindRequest = () => ({
    type: ORDERS_FIND_REQUEST
});

const ordersFindReceive = numbers => ({
    type: ORDERS_FIND_RECEIVE,
    numbers
});

const ordersFindFetch = () => {
    return dispatch => {
        dispatch(ordersFindRequest());
        return authFetch(urls.orders).then(json => {
            const numbers = json.results.map(order => order.number);
            const items = json.results.reduce((result, item) => {
                item.didInvalidate = true;
                result[item.number] = item;
                return result;
            }, {});
            dispatch(ordersAddList(items));
            dispatch(ordersFindReceive(numbers));
            const { min, max, step } = calculatePriceBounds(json.results);
            dispatch(ordersFindSetPriceBounds(min, max, step));
        });
    };
};

const ordersFindShouldFetch = state => {
    const ordersFind = state.ordersFind;
    if (ordersFind.isFetching) {
        return false;
    }
    if (ordersFind.updatedAt && moment().diff(ordersFind.updatedAt, 'minutes') > 1) {
        return true;
    }
    return ordersFind.didInvalidate;

};

export const ordersFindFetchIfNeeded = () => {
    return (dispatch, getState) => {
        if (ordersFindShouldFetch(getState())) {
            return dispatch(ordersFindFetch());
        }
    };
};

export const ordersFindSetSorting = value => {
    return {
        type: ORDERS_FIND_SET_SORTING,
        value
    };
};

export const ordersSetFilterTime = (typeId, value) => {
    return {
        type: ORDERS_FIND_SET_FILTER_TIME,
        typeId,
        value
    }
};

export const ordersSetFilterGroup = (typeId, value) => {
    return {
        type: ORDERS_FIND_SET_FILTER_GROUP,
        typeId,
        value
    }
};

export const ordersSetFilterPrice = (typeId, min, max) => {
    return {
        type: ORDERS_FIND_SET_FILTER_PRICE,
        typeId,
        min,
        max
    }
};

export const ordersSetFilterSearch = (typeId, value) => {
    return {
        type: ORDERS_FIND_SET_FILTER_SEARCH,
        typeId,
        value
    }
};

export const ordersFindSetFilterSubject = (typeId, value) => {
    return {
        type: ORDERS_FIND_SET_FILTER_SUBJECT,
        typeId,
        value
    }
};

export const ordersFindSetFilterType = (typeId, set, value) => {
    return {
        type: ORDERS_FIND_SET_FILTER_TYPE,
        typeId,
        set,
        value
    }
};

const calculatePriceBounds = orderList => {
    const prices = orderList.map(order => order.pregrader_price);
    let max = prices.length ? Math.max(...prices) : 0;
    const stepNumber = 20;
    let step = Math.ceil(max / stepNumber);

    if (step > 75) {
        // do nothing
    } else if (step > 50) {
        step = 75;
    } else if (step > 30) {
        step = 50;
    } else if (step > 20) {
        step = 30;
    } else if (step > 15) {
        step = 20;
    } else if (step > 10) {
        step = 15;
    } else if (step > 5) {
        step = 10;
    }

    max = step * stepNumber;
    return { min: 0, max, step };
};



// WEBPACK FOOTER //
// ./src/store/ordersFind/actions.js